export class AssetTypeModel {
  id: number;
  name: string;
  isActive: boolean;
  createdBy: string;
  createdDate: Date;
  updatedDate: Date;
}
